'use client';

import { useClientLocale, useClientTranslation } from '@bts-web/utils-lokalise';
import { TFunction } from 'i18next';
import { useCryptoTransferTransactionDetails } from '../hooks/useCryptoTransferTransactionDetails.use-client';
import { getTransactionDetailsTranslations } from '../../transaction-details/utils';
import { CryptoTransferDetails } from '../CryptoTransferDetails/CryptoTransferDetails';
import {
  TransactionDetailsLayout,
  TransactionDetailsSkeleton,
} from '../../transaction-details';
import { Drawer } from '../../common/components/Drawer/Drawer';
import { CryptoTransfersTransactionsItemType } from '../../transaction-details/types';

export const transactionDetailsDrawerId = 'transaction_details_drawer';

export const CryptoTransferDetailsDrawer = ({
  cryptoTransferId,
  title,
}: {
  cryptoTransferId: string;
  title?: string | null;
}) => {
  const {
    cryptoTransferTransaction,
    isCryptoTransferTransactionFetching,
    refetchCryptoTransfersTransactions,
  } = useCryptoTransferTransactionDetails({
    cryptoTransferId,
  });

  const locale = useClientLocale();

  const { t } = useClientTranslation();

  const translations = getTransactionDetailsTranslations(t as TFunction);

  return (
    <Drawer title={translations.topBar}>
      <TransactionDetailsLayout>
        {isCryptoTransferTransactionFetching ? (
          <TransactionDetailsSkeleton />
        ) : (
          <CryptoTransferDetails
            cryptoTransferTransaction={
              cryptoTransferTransaction as NonNullable<CryptoTransfersTransactionsItemType>
            }
            locale={locale}
            translations={translations}
            title={title}
            refetchCryptoTransfersTransactions={
              refetchCryptoTransfersTransactions
            }
          />
        )}
      </TransactionDetailsLayout>
    </Drawer>
  );
};
